<template>
  <div class="formPage">
    <div class="formPage--form">
      <form @submit.prevent="login">
        <div>
          <div class="form-group">
            <label for="email">Email</label>
            <input type="text" maxlength="200" id="email" v-model="user.email" class="form-control" />
          </div>
          <div class="form-group">
            <label for="password">Password</label>
            <input type="password" id="password" v-model="user.password" class="form-control" />
          </div>
        </div>

        <div>
          <button class="btn btn-primary" v-if="!loading">Login</button>
          <button class="btn btn-primary" type="button" disabled v-else>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Loading
          </button>
        </div>
      </form>
      <div class="alert alert-danger" role="alert" v-if="error">
        <p>{{error}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { setCookie } from "../cookie.js";
import { herokuUrl } from "../apiConfig";
export default {
  data() {
    return {
      loading: false,
      user: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    login() {
      if (this.user.email.length === 0) {
        this.error = "please Enter user email";
      } else if (this.user.password.length === 0) {
        this.error = "please Enter user password";
      } else {
        this.error = null;
        this.loading = true;
        axios
          .post(`${herokuUrl}/dashboard/login`, {
            email: this.user.email,
            password: this.user.password,
            language: 1
          })
          .then(response => {
            this.loading = false;
            if (response.data.status) {
              setCookie("user", response.data.access_token);
              this.$router.push({ path: "/manage-product" });
            } else {
              this.error = response.data.message;
            }
          })
          .catch(err => {
            this.loading = false;
            this.error = err.data.message;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.formPage {
  height: 100%;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  &--form {
    padding: 50px 20px;
    background: #fff;
    width: 30%;
    margin: auto;
    .form-group {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    button {
      width: 150px;
    }
  }
}
</style>
